import React from 'react';
import { useHistory } from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { TEACHER_ASSIGNMENT_V2_INSIGHTS_URL } from 'config/urls';

import LoadingSkeleton from 'pages/Teachers/Insights/components/LoadingSkeleton';
import { reverse } from 'utils/urls';

import styles from './style.module.scss';

const ClassroomHeader = ({
  sectionDetails,
  studentsCount,
  trackerInstanceSectionId
}) => {
  const history = useHistory();

  if (!sectionDetails) {
    return <LoadingSkeleton />;
  }

  const { tracker_name, section_name } = sectionDetails;

  return (
    <div className={styles.container}>
      <div className={styles.navigation}>
        <button
          className={styles.back}
          onClick={() => {
            history.goBack();
          }}
        >
          <ArrowBackIcon />
          <span>Back</span>
        </button>
        <button
          className={styles.insightsButton}
          onClick={() => {
            history.push({
              pathname: reverse(TEACHER_ASSIGNMENT_V2_INSIGHTS_URL, {
                trackerInstanceSectionId
              })
            });
          }}
        >
          <span>Switch to old Insights experience</span>
          <ArrowBackIcon />
        </button>
      </div>

      <div className={styles.headingContainer}>
        <div className={styles.titles}>
          <h1 className={styles.heading}>{tracker_name}</h1>
          {section_name && <p className={styles.subheading}>{section_name}</p>}
        </div>

        {studentsCount === 0 ? (
          <CircularProgress />
        ) : (
          <div className={styles.studentCount}>{studentsCount} students</div>
        )}
      </div>
    </div>
  );
};

export default ClassroomHeader;
